import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import styles from './ShopperCard.module.css';
import {toStringMesTextoFromFechaCompletoFromString} from "../../utils/fecha";
import DownloadSVG from "../../images/download.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faArrowRight, faDownload} from "@fortawesome/free-solid-svg-icons";

export function ShopperCard({shopperStrapi}) {

    const shopperData = shopperStrapi.attributes || shopperStrapi;

    const shopper = {
        id: shopperStrapi.id,
        nombre: shopperData.nombre,
        fechaInicio: shopperData.fechaInicio,
        fechaFinal: shopperData.fechaFinal,
        pdf: shopperData.pdf?.url || shopperData.pdf?.data?.attributes?.url,
        slug: shopperData.slug,
        imagenPrincipal: shopperData.imagenPrincipal?.url || shopperData.imagenPrincipal?.data?.attributes?.url,
        idBotonInterno: shopperData.idBotonInterno,
        idBotonExterno: shopperData.idBotonExterno
    }
    return (
        <>
            <div className="border-radius-10 d-flex align-items-end" style={{ height:"562px", width: "100%", background: `url(${shopper.imagenPrincipal})`, backgroundSize: "cover"}}>
                <div className={styles.paddingContainer}>
                    <div className={styles.textContainer}>
                        <div className={`${styles.tituloShopper}`}>{shopper.nombre}</div>
                        <div className={`${styles.fechasShopper}`}>
                            {`Válido del ${toStringMesTextoFromFechaCompletoFromString(shopper.fechaInicio)} 
                            al ${toStringMesTextoFromFechaCompletoFromString(shopper.fechaFinal)}`}
                        </div>
                    </div>
                    <Row>
                        <Col sm={2} md={2} className={`mb-4 d-sm-none d-md-block`}>
                            <Button id={shopper.idBotonExterno}
                                    className={`${styles.btnDownload}`}
                                    target="_blank"
                                    href={shopper.pdf} download>
                                <span className="material-symbols-outlined">download</span>
                            </Button>
                        </Col>
                        <Col sm={2} md={2} className={"py-4 py-md-0"}>
                            <Button className={`${styles.btnShopper}`} href={'/publicaciones/'+shopper.slug}>
                                <span className="material-symbols-outlined">arrow_right_alt</span>
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>
        </>)
}

export default ShopperCard;
